import { ticketSellerRouteNames } from '../../../../routing/routeNames/ticketSellerRouteNames'

const { tickets, purchase, orders, orderDetails, reports, report } = ticketSellerRouteNames

/**
 * Sidebar keys for mapping routes to sidebar links
 * Some are string literals because for those links there isn't any route, they are just dropdowns for their subroutes
 *
 * They are in order as they are in Sidebar
 */
const sidebarKeys = {
  tickets: tickets,
  orders: orders,
  orderDetails: orderDetails,
  reports: reports,
}

/**
 * Sidebar links - objects for sidebar configuration
 *
 * Type:
 * {
 *    label: Name displayed in sidebar
 *    icon: Name of icon, representing the one inside assets/sidebar-icons
 *    key: Key for mapping the link to sidebar, take from sidebarKeys
 *    linkedRoutes: List of all routes for which this link will be highlighted as active and disabled for clicking (including its internal route)
 *    internalRoute: {
 *      name: Name of route this link will lead to, take from routeNames object
 *    }
 * }
 */
export const ticketSellerSidebarConfiguration = [
  // {
  //   label: 'Dashboard',
  //   icon: 'dashboard',
  //   internalRoute: {
  //     name: ticketSellerRouteNames.dashboard,
  //   },
  // },
  {
    label: 'Tickets',
    icon: 'tickets',
    key: sidebarKeys.tickets,
    linkedRoutes: [tickets, purchase],
    internalRoute: {
      name: ticketSellerRouteNames.tickets,
    },
  },
  {
    label: 'Orders',
    icon: 'orders',
    key: sidebarKeys.orders,
    linkedRoutes: [orders, orderDetails],
    internalRoute: {
      name: ticketSellerRouteNames.orders,
    },
  },
  {
    label: 'Reports',
    icon: 'reports',
    key: sidebarKeys.reports,
    linkedRoutes: [reports, report],
    internalRoute: {
      name: ticketSellerRouteNames.reports,
    },
  },
]
